import { ConstructClassWithPrivateMembers } from '../helpers/ClassWithPrivateMembers';
import { IsObject } from '../../helpers';
export const REASON_PRIVATE = Symbol('reason-private');
export function ConstructReason(instance, options, code, stack) {
    ConstructClassWithPrivateMembers(instance, REASON_PRIVATE);
    const privates = instance[REASON_PRIVATE];
    let _options;
    if ((options === void 0) || (typeof options === 'string')) {
        _options = {
            message: options,
            code: code,
            stack: stack,
        };
    }
    else if (IsObject(options) && (code === void 0) && (stack === void 0)) {
        _options = options;
    }
    else {
        throw new TypeError(`Expected Reason(object?) or Reason(string?, T?, string?)`);
    }
    if (typeof _options.message === 'string') {
        privates.message = _options.message;
    }
    else {
        throw new TypeError(`Expected string as Reason.options.message`);
    }
    privates.code = _options.code;
    if (_options.stack === void 0) {
        privates.stack = (new Error(privates.message).stack || '').replace('Error', 'Reason');
    }
    else if (typeof _options.stack === 'string') {
        privates.stack = _options.stack;
    }
    else {
        throw new TypeError(`Expected string or void as Reason.options.stack`);
    }
}
export function IsReason(value) {
    return IsObject(value)
        && value.hasOwnProperty(REASON_PRIVATE);
}
export class Reason {
    constructor(options, code, stack) {
        ConstructReason(this, options, code, stack);
    }
    get message() {
        return this[REASON_PRIVATE].message;
    }
    get code() {
        return this[REASON_PRIVATE].code;
    }
    get stack() {
        return this[REASON_PRIVATE].stack;
    }
    toJSON() {
        return {
            message: this.message,
            code: this.code,
            stack: this.stack,
        };
    }
}
//# sourceMappingURL=implementation.js.map